/**
 * OpenAI service for fetching word definitions
 * Uses a server-side proxy in development to keep API key secure
 */

export type DefinitionResult = {
  word: string;
  definition: string;
  partOfSpeech?: string;
  examples?: string[];
  etymology?: string;
  scrabbleTip?: string;
};

/**
 * Fetches a word definition using OpenAI via the server proxy
 */
export async function getWordDefinition(word: string): Promise<DefinitionResult> {
  const response = await fetch('/api/definition', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ word: word.toUpperCase() }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Failed to fetch definition' }));
    throw new Error(error.error || 'Failed to fetch definition');
  }

  return response.json();
}
